<section *ngIf="!hideHeader"  class="section-title" [style.background-image]="backgroundImage">

  <div class="section-title-image">
    <img class="device-image" src="assets/img/group3.png" />
  </div>

  <div class="section-title-text">
    <h1 i18n="@@groupslist_title">Gruppi</h1>

  </div>

</section>

<section class="section-content">

  <div *ngIf="!hideHeader && canUserEdit"  class="buttons-container">

    <a (click)="addGroup()" class="button">
      <ng-container i18n="@@groupslist_add_group">Aggiungi gruppo</ng-container> <span>
        <fa-icon icon="user"></fa-icon>
      </span>
    </a>
  </div>

  <div class="table-filter">
    <p i18n="@@groupslist_filter">Filtra: </p>
    <input id="filter-input" (keyup)="onKey($event)" />
  </div>

  <div class="table-container">

    <table mat-table matSort #groupslisttable class="simple-table">

      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@groupslist_name" style="width: 30%;">Nome</th>
        <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@groupslist_description" style="width: 30%;">Descrizione</th>
        <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
      </ng-container>

      <!-- <ng-container matColumnDef="user">
        <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@groupslist_email" style="width: 45%;">Utente</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.userUid">
            {{ element.user?.displayName }}
          </ng-container>
          <ng-container *ngIf="!element.userUid">
            <ng-container i18n="@@groupslist_user_not_linked" style="width: 10%;">App non attivata</ng-container>
          </ng-container>
        </td>
      </ng-container> -->

      <ng-container matColumnDef="modifyGroup">
        <th mat-header-cell *matHeaderCellDef i18n="@@adduserlist_tableHeader_modify"> </th>
        <td mat-cell *matCellDef="let element">
          <fa-icon icon="edit" class="float-right padding-5 icon-clickable" (click)="onRowClicked(element)"></fa-icon>
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="version">
              <th mat-header-cell *matHeaderCellDef i18n="@@groupslist_type">Versione</th>
              <td mat-cell *matCellDef="let element">
                  {{ element.systemInfo.version }}
                  <fa-icon icon="chevron-right" class="float-right padding-5"></fa-icon>
              </td>
          </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <!-- tutta la riga cliccabile
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"
        [class.mat-cell-selected]="selectedRow == row.id" class="clickable">
      </tr> -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

  </div>

  <app-loading-screen #groupslistloader></app-loading-screen>

</section>
